import React from "react";
import Background from "../images/tickers.png";
import Path from '../images/path.png';
import { Box, Container } from "@mui/system";
import { Button, Skeleton, Typography, useMediaQuery } from "@mui/material";

export default function CallToAction({data}){

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));

    return(
        <Box
            sx={{
                backgroundImage: `url(${Background}), url(${Path})`,
                backgroundSize:'cover',
                backgroundBlendMode:'multiply',
                p:{
                    xs:'6rem 0 3rem 0',
                    md:'25vh 0 12.5vh 0'
                },
                color:"#fff"
            }}
        >
            <Container maxWidth='xl'>
            <Typography variant='h2' component='h2'
                    sx={{
                        fontSize:'1.4rem',
                        fontWeight:600
                    }}
                >
                    {data? data.heading : <Skeleton/>}
                </Typography>
                <Typography variant='p' component='p'
                    sx={{
                        m:'1rem 0 2rem 0'
                    }}
                >
                    {data? data.paragraph : <Skeleton/>}
                </Typography>
                <Button
                    sx={{
                        backgroundColor:'#E9531C',
                        color:'#fff',
                        borderRadius:'2rem',
                        fontSize:'1rem',
                        p:'0.5rem 2rem'
                    }}
                >
                    {data? data.button_text : <Skeleton/>}
                </Button>
            </Container>
        </Box>
    )
}